<template>
  <header
    class="backdrop-blur bg-surface-canvas/95 border-b border-border-level-200 dark:bg-surface-level-900/95 dark:border-border-level-700 sticky top-0 z-(--z-index-ds-sticky)"
  >
    <nav
      class="flex items-center justify-center lg:px-8 p-4"
      :aria-label="$t('common.accessibility.globalNavigation')"
    >
      <div class="flex">
        <Logo
          wrapper-class="-m-1.5 p-1.5"
          height-class="h-14"
          alt=""
        />
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
// Simple navigation component with only the logo centered
</script>
